const LABEL = {
    PENDING: "pending",
    REJECTED: "denied",
    APPROVED: "approved",
    COMPLETED: "completed"
};

export default {
    LABEL
};
